// Services.
import { WaHelperService } from '../../wa-services/wa-helper-service';


export class EventBaseItem {

  public id: number;
  public name: string;
  public nameshort: string;
  public venue: string;
  public eventype: string;
  public level: string;
  public country: string;
  public sublevel: string;
  public isfeatured: boolean;
  public comhideinLive: string;
  public options: Array<string> = [];
  public catInd: Array<string> = [];
  public catTeam: Array<string> = [];
  public status: string;
  public stages: Array<any> = [];
  public youtubelive: string;
  public links: any = {};
  public comdivisions: Array<number> = [];
  protected _countryName: string;


  constructor(rawEventGeneralInfoItem: any, protected waHelperService: WaHelperService) {
    // @TODO: COMPETITIONS = Id; ATHLETERESULTS = ID
    this.id = EventBaseItem.readData(rawEventGeneralInfoItem, 'ID', 'Id');
    this.name = rawEventGeneralInfoItem.Name;
    this.country = rawEventGeneralInfoItem.Country;
    this.nameshort = rawEventGeneralInfoItem.NameShort;
    this.venue = rawEventGeneralInfoItem.Venue;
    this.eventype = rawEventGeneralInfoItem.EventType;
    this.level = rawEventGeneralInfoItem.Level;
    this.sublevel = rawEventGeneralInfoItem.SubLevel;
    this.isfeatured = rawEventGeneralInfoItem.IsFeatured;
    this.comhideinLive = rawEventGeneralInfoItem.ComHideInLive;
    this.options = rawEventGeneralInfoItem.Options;
    this.catInd = rawEventGeneralInfoItem.CatInd;
    this.catTeam = rawEventGeneralInfoItem.CatTeam;
    this.status = rawEventGeneralInfoItem.Status;
    this.stages = rawEventGeneralInfoItem.Stages;
    this.youtubelive = rawEventGeneralInfoItem.YoutubeLive;
    this.links = rawEventGeneralInfoItem.Links ? rawEventGeneralInfoItem.Links : this.links;
    this.comdivisions = rawEventGeneralInfoItem.ComDivisions
  }

  protected static readData(item: any, f1: string, f2: string) {
    let value;
    if (typeof item[f1] !== 'undefined') {
      value = item[f1];
    }
    else if (typeof item[f2] !== 'undefined') {
      value = item[f2];
    }
    return value;
  }

  public get logo(): string {
    return 'https://extranet.worldarchery.sport/CompetitionLogos/?Id=' + this.id;
  }

  public get webUrl(): string {
    return 'https://worldarchery.sport/competition/' + this.id;
  }

  public get flag(): string {
    return 'https://extranet.worldarchery.sport/Flags/' + this.country + '-S.png';
  }

  public get countryName(): string {
    return this.waHelperService.nocToCountryName(this.country);
  }

  protected static dateCompare(dateA: string, dateB: string) {
    if (dateA < dateB) {
      return -1;
    }
    if (dateA > dateB) {
      return 1;
    }

    return 0;
  }
}
